import React from 'react';
import styled from 'styled-components';
import subtitles from './subtitles.svg';
import audio from './audio-wave.svg';
import world from './world.svg';
import theme from '../../../theme';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: ${theme.smallScreenCutoff}) {
    justify-content: center;
  }
`;
const Feature = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  margin: 20px;
  width: 80px;
  height: 100px;
`;

const FeatureContent = styled.div`
  max-width: 190px;
`;

const FeatureTitle = styled.h5`

`;

const FeatureText = styled.div`

`;

class Features extends React.Component {
  render() {
    return (
      <Container>
        <Feature>
          <div><Image src={subtitles} alt="subtitles"/></div>
          <FeatureContent>
            <FeatureTitle>Real-time subtitles</FeatureTitle>
            <FeatureText>
              Subtitles appear on your screen in real time.
            </FeatureText>
          </FeatureContent>
        </Feature>
        <Feature>
          <div><Image src={audio} alt="audio"/></div>
          <FeatureContent>
            <FeatureTitle>Works with any audio</FeatureTitle>
            <FeatureText>
              Transcribe any audio: videos, podcasts, microphone.
            </FeatureText>
          </FeatureContent>
        </Feature>
        <Feature>
          <div><Image src={world} alt="world"/></div>
          <FeatureContent>
            <FeatureTitle>Supports 100+ languages</FeatureTitle>
            <FeatureText>
              Translate audio on the fly into any of 100+ languages.
            </FeatureText>
          </FeatureContent>
        </Feature>
      </Container>
    )
  }
}

export default Features;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/Features/index.js